<template>
	<div class="landing-gender-buttons" :style="customStyles">
		<button
			class="landing-gender-buttons__btn landing-gender-buttons__btn_female"
			type="button"
			data-control="button"
			data-button-type="gender"
			data-value="female"
			@click="onSelect('female')"
		>
			{{ femaleLabel }}
		</button>
		<button
			class="landing-gender-buttons__btn landing-gender-buttons__btn_male"
			type="button"
			data-control="button"
			data-button-type="gender"
			data-value="male"
			@click="onSelect('male')"
		>
			{{ maleLabel }}
		</button>
	</div>
</template>

<script>
export default {
	name: 'LandingGenderButtons',

	props: {
		femaleLabel: {
			type: String,
			required: true,
		},

		maleLabel: {
			type: String,
			required: true,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},

	emits: ['sexSelected'],

	methods: {
		onSelect(sex) {
			this.$emit('sexSelected', sex)
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-gender-buttons {
	display: flex;
	flex-direction: column;
	gap: var(--size-12);
	margin-top: var(--size-24);
	margin-bottom: var(--size-16);

	&__btn {
		width: 100%;
		height: var(--size-48);
		border: none;
		border-radius: var(--size-16);
		font-size: var(--size-16);
		font-weight: 600;
		color: var(--Text-On-Color);
		cursor: pointer;

		&_female {
			background-color: var(--Fill-Accent-100);
		}

		&_male {
			background-color: var(--Fill-Inverse);
		}
	}
}
</style>
